<template>
	<div class="address">
		<infoHeader :title="title" icon="el-icon-position"></infoHeader>
		<div class="fixation">
			<div class="register-form">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="120px">
					<div class="welcome">
						编辑收货地址
					</div>
					<el-form-item label="行政区划" prop="administrative">
						<el-cascader v-model="ruleForm.administrative" :options="optionsData"
							:props="{label:'name',value:'name'}" @change="addressChange" placeholder="请选择行政区划"
							style="width: 100%;"></el-cascader>
					</el-form-item>
					<el-form-item label="详细地址" prop="detail">
						<el-input type="text" v-model="ruleForm.detail" placeholder="请输入详细地址"></el-input>
					</el-form-item>
					<el-form-item label="邮政编码" prop="code">
						<el-input v-model="ruleForm.code" placeholder="请输入邮政编码"></el-input>
					</el-form-item>
					<el-form-item label="收货人姓名" prop="name">
						<el-input type="text" v-model="ruleForm.name" placeholder="请输入收货人姓名"></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="phone">
						<el-input v-model="ruleForm.phone" placeholder="请输入收货人手机号"></el-input>
					</el-form-item>
					<el-form-item label="邮箱" prop="email">
						<el-input type="text" v-model="ruleForm.email" placeholder="请输入收货人邮箱"></el-input>
					</el-form-item>
					<el-form-item>
						<div class="dialog-button">
							<el-button type="danger" plain @click="resetForm('ruleForm')">重置</el-button>
							<el-button type="danger" @click="submitForm('ruleForm')">保存</el-button>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="dialog-agreement">
							<el-checkbox v-model="checked"></el-checkbox>设为默认地址
						</div>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-dialog :visible="successDialog" :show-close="false" top="280px" width="600px">
			<div class="login-dialog-title">
				<i class="el-icon-circle-check"></i>保存地址成功
			</div>
			<div class="button">
				<el-button @click="closeSuccess, goBack()" plain type="danger" round>返回</el-button>
			</div>
		</el-dialog>
		<pubfooter></pubfooter>
	</div>
</template>

<script>
	import optionsData from '../../public/area.json';
	export default {
		name: 'address',
		data() {
			let verify_phone = (rule, value, callback) => {
				if (!this.$ver.verify_phone(this.ruleForm.phone)) {
					callback(new Error('手机号格式错误'))
				} else {
					callback()
				}
			}
			let verify_email = (rule, value, callback) => {
				if (!this.$ver.verify_email(this.ruleForm.email)) {
					callback(new Error('邮箱格式错误'))
				} else {
					callback()
				}
			}
			return {
				title: '编辑收货地址',
				optionsData: optionsData,
				ruleForm: {
					administrative: [],
					detail: '',
					name: '',
					phone: '',
					code: '',
					email: ''
				},
				rule: {
					administrative: [{
						required: true,
						trigger: 'blur',
						message: '请选择行政区划'
					}],
					detail: [{
						required: true,
						trigger: 'blur',
						message: '请输入详细地址'
					}],
					name: [{
						required: true,
						trigger: 'blur',
						message: '请输入收货人姓名'
					}],
					phone: [{
						required: true,
						trigger: 'blur',
						validator: verify_phone
					}],
					email: [{
						required: true,
						trigger: 'blur',
						validator: verify_email
					}]
				},
				checked: false,
				disabled: false,
				successDialog: false,
				id: ''
			};
		},
		methods: {
			goBack() {
				this.$router.back()
			},
			resetForm(formName) {
				this.$refs[formName].resetFields()
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.frontAddressAdd({
							id: this.id,
							city: this.ruleForm.administrative.join(','),
							addressDetail: this.ruleForm.detail,
							isDefaultAddress: this.checked ? 1 : 0,
							receiverName: this.ruleForm.name,
							postalCode: this.ruleForm.code,
							receiverPhone: this.ruleForm.phone,
							memberId: this.$store.state.userinfo.userId,
							email: this.ruleForm.email
						}, res => {
							if (res.code == 200) {
								this.successDialog = true
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			closeSuccess() {
				this.successDialog = false
			},
			addressChange(e) {
				console.log(e)
			},
			fetchAddress() {
				this.$api.frontAddressDetail({
					id: this.id
				}, res => {
					if (res.code == 200) {
						this.ruleForm = {
							administrative: res.data.city.split(','),
							detail: res.data.addressDetail,
							name: res.data.receiverName,
							code: res.data.postalCode,
							phone: res.data.receiverPhone,
							email: res.data.email
						}
						this.checked = res.data.isDefaultAddress == 1 ? true : false
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.id = this.$route.query.id
			if (this.id != '') {
				this.fetchAddress()
			}
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.fixation {
		display: flex;
		justify-content: center;
		padding: @vue-spacing-col-lg*2 0px;
	}

	.login-dialog-title {
		width: 100%;
		height: 80px;
		display: flex;
		justify-content: center;
		font-size: @vue-font-size-lg;
		color: @vue-text-color-red;

		i {
			margin-top: @vue-spacing-col-sm;
			margin-right: @vue-spacing-row-sm;
		}
	}

	.button {
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top: @vue-spacing-col-lg;
	}
</style>
